import { render, staticRenderFns } from "./TaskAttachments.vue?vue&type=template&id=440dc3aa&scoped=true"
import script from "./TaskAttachments.vue?vue&type=script&lang=js"
export * from "./TaskAttachments.vue?vue&type=script&lang=js"
import style0 from "./TaskAttachments.vue?vue&type=style&index=0&id=440dc3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440dc3aa",
  null
  
)

export default component.exports